import { Controller } from 'stimulus';

class OpportunityHasRespondedController extends Controller {
  static targets = ['checkbox'];

  handleModalAction(e) {
    // If the modal closes, the checkbox reverts
    if (e?.detail?.state === false) {
      this.checkboxTarget.checked = false;
    }
  }
}

export default OpportunityHasRespondedController;
